import { connect } from "react-redux";
import React, { Component } from "react";
import glamorous from "glamorous";
import { InputGroup, FormControl, MenuItem } from "react-bootstrap";
import _ from "lodash";

import colors from "../../styles/colors";
import { Logo } from "../../components/logos";
import fv from "../../assets/fv_badge.png";
import { screenForLocation } from "../../routes";
import { Roles, hasRole } from "../auth/authorization";
import { BooleanValue } from "../../../node_modules/react-values";
import { FlexColDiv, FlexDiv } from "../../styles/container-elements";
import Search from "react-icons/lib/fa/search";
import { setSearchStr } from "./HeaderBarState";
import { setCurrentOrganization } from "../organizations/OrganizationsState";

const LogoText = glamorous.span(props => ({
  fontSize: "1.5em",
  fontWeight: "300",
  color: colors.background.GRAY_BLUE,
  marginLeft: ".5em",
  ...props
}));

const OrgSearchBar = ({ placeholderStr, searchStr, setSearchStr, style }) => {
  return (
    <glamorous.Div
      css={{
        display: "flex",
        flexDirection: "row",
        marginBottom: "1em",
        ...style
      }}
    >
      <InputGroup
        style={{
          border: "1px solid rgba(0, 0, 0, 0.1)",
          boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.1)",
          borderRadius: "3px",
          flex: 1
        }}
      >
        <Search
          style={{
            color: colors.background.DARK_BLUE,
            position: "absolute",
            left: "0.8em",
            top: "0.85em",
            zIndex: 1
          }}
        />
        <FormControl
          type="text"
          onChange={e => setSearchStr(e.target.value)}
          placeholder={placeholderStr}
          value={searchStr}
          style={{
            backgroundColor: "white",
            border: "none",
            boxShadow: "none",
            flex: 1,
            height: "2.8em",
            paddingLeft: "2.4em",
            borderRadius: "3px",
            zIndex: 0
          }}
        />
      </InputGroup>
    </glamorous.Div>
  );
};

const OrgItem = ({ org, ind, active, toggle, setCurrentOrganization }) => {
  // let haloElem = active ? (
  //   <glamorous.Div
  //     css={{
  //       position: "absolute",
  //       top: 0
  //     }}
  //   >
  //     <svg height="52" width="52">
  //       <circle
  //         cx="25.5"
  //         cy="25.5"
  //         r="25"
  //         stroke={colors.highlight.YELLOW}
  //         strokeWidth="2"
  //         fill="transparent"
  //       />
  //     </svg>
  //   </glamorous.Div>
  // ) : null;

  let activeElem = active ? (
    <glamorous.Div
      css={{
        color: colors.highlight.YELLOW,
        fontStyle: "italic",
        position: "absolute",
        top: 10,
        right: "1em"
      }}
    >
      Active
    </glamorous.Div>
  ) : null;

  return (
    <MenuItem
      eventKey={ind}
      className="select-item"
      style={{
        backgroundColor: ind % 2 === 0 ? colors.tableHeadingText : "white",
        padding: 0
      }}
      onClick={() => {
        setCurrentOrganization(org.organization_id);
        toggle();
      }}
    >
      <glamorous.Div
        css={{
          margin: 0,
          paddingLeft: ".5em",
          paddingTop: ".5em",
          paddingBottom: ".5em"
        }}
      >
        <FlexDiv>
          <FlexColDiv
            css={{
              flex: 1,
              justifyContent: "center",
              marginLeft: "1em",
              position: "relative"
            }}
          >
            <glamorous.Div
              css={{ color: colors.bannerText, fontWeight: "bold" }}
            >
              {org.org_name}
            </glamorous.Div>
            <glamorous.Div css={{ color: "#DBDBDB" }}>
              {org.org_type}
            </glamorous.Div>
            {activeElem}
          </FlexColDiv>
        </FlexDiv>
      </glamorous.Div>
    </MenuItem>
  );
};

const OrganizationSelect = ({
  currentOrganizationId,
  organizations,
  searchStr,
  setCurrentOrganization,
  setSearchStr,
  toggle
}) => {
  let orgElem = organizations.map((org, i) => (
    <OrgItem
      ind={i}
      key={i}
      org={org}
      toggle={toggle}
      active={org.organization_id === currentOrganizationId}
      setCurrentOrganization={setCurrentOrganization}
    />
  ));

  return (
    <FlexColDiv
      css={{
        backgroundColor: "white",
        boxShadow: "4px 4px 8px 8px rgba(145,145,145,.5)",
        minHeight: "12em",
        position: "absolute",
        top: 52,
        right: 10,
        width: "24em",
        zIndex: 200
      }}
    >
      <FlexColDiv style={{ padding: "1em", position: "relative" }}>
        <FlexDiv
          css={{
            color: colors.formHeadingColor,
            fontWeight: 450,
            marginBottom: ".25em"
          }}
        >
          Organizations
        </FlexDiv>
        <FlexDiv css={{ flex: 1 }}>
          <OrgSearchBar
            style={{ flex: 1, marginBottom: 0 }}
            placeholderStr={`Search Organizations`}
            searchStr={searchStr}
            setSearchStr={setSearchStr}
          />
        </FlexDiv>
        <glamorous.Div
          css={{
            borderLeft: "8px solid transparent",
            borderRight: "8px solid transparent",
            borderBottom: "8px solid white",
            top: -8,
            height: 0,
            position: "absolute",
            right: 23,
            width: 0
          }}
        />
      </FlexColDiv>
      <glamorous.Ul
        css={{
          display: "block",
          height: "15.5em",
          listStyle: "none",
          margin: 0,
          overflow: "auto",
          padding: 0,
          "> .select-item > a:hover": {
            textDecoration: "none"
          },
          "> .select-item > a:hover > div": {
            backgroundColor: "#FCFCC7"
          }
        }}
      >
        {orgElem}
      </glamorous.Ul>
    </FlexColDiv>
  );
};

class HeaderBar extends Component {
  findCurrentOrg() {
    const { currentOrganizationId, organizations } = this.props;

    let org = null;

    if (currentOrganizationId != null) {
      org = _.find(organizations, {
        organization_id: parseInt(currentOrganizationId, 10)
      });
    }

    return org;
  }

  render() {
    const {
      currentOrganizationId,
      location,
      roles,
      organizations,
      searchStr,
      setSearchStr,
      setCurrentOrganization
    } = this.props;
    const currentScreen = screenForLocation(location);
    const fvAdmin = hasRole(Roles.FREIGHTVERIFY_ADMIN, roles);

    let filteredOrganizations = [];
    if (searchStr != null && !_.isEmpty(organizations)) {
      filteredOrganizations = organizations.filter(o => {
        return (
          !o.deleted_at &&
          o.org_name &&
          o.org_name.toLowerCase().includes(searchStr.toLowerCase())
        );
      });
    }

    let currentOrg = this.findCurrentOrg();

    return (
      <glamorous.Header
        css={{
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          position: "relative"
        }}
      >
        <FlexDiv>
          <LogoText>{currentScreen ? currentScreen.title : ""}</LogoText>
        </FlexDiv>
        <FlexDiv
          css={{
            alignItems: "center",
            justifyContent: "center",
            marginRight: "1em"
          }}
        >
          <FlexDiv
            css={{
              color: colors.formHeadingColor,
              marginRight: "1em",
              fontSize: "medium"
            }}
          >
            {currentOrg ? currentOrg.org_name : ""}
          </FlexDiv>
          <BooleanValue>
            {({ value: opened, toggle }) => (
              <glamorous.Div>
                <glamorous.Div
                  style={{
                    cursor: "pointer"
                  }}
                  onClick={toggle}
                >
                  <Logo src={fv} style={{ height: 35, width: 35 }} />
                </glamorous.Div>
                {opened && fvAdmin ? (
                  <OrganizationSelect
                    currentOrganizationId={parseInt(currentOrganizationId, 10)}
                    setCurrentOrganization={setCurrentOrganization}
                    searchStr={searchStr}
                    setSearchStr={setSearchStr}
                    toggle={toggle}
                    organizations={filteredOrganizations}
                  />
                ) : null}
              </glamorous.Div>
            )}
          </BooleanValue>
        </FlexDiv>
      </glamorous.Header>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state.header,
    roles:
      state.roles.data && state.roles.data.response
        ? state.roles.data.response.roles
        : state.roles.data,
    organizations:
      state.organizations.data && state.organizations.data.response
        ? state.organizations.data.response
        : [],
    currentOrganizationId: state.organizations.currentOrganizationId
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setCurrentOrganization: id => dispatch(setCurrentOrganization(id)),
    setSearchStr: str => dispatch(setSearchStr(str))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderBar);



// WEBPACK FOOTER //
// ./src/modules/header-bar/HeaderBarView.js